import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { deleteEngageMessage } from 'api/engage';
import { useLetterActions } from 'assets/js/pages/engage/letters/useLetterActions';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { isQueryKeyIndexMeta } from 'helpers/reactQuery';
import { GivebutterAxiosError } from 'types/error';

const useDeleteLetter = (options: UseMutationOptions<unknown, unknown, number, any> = {}) => {
    const { invalidate } = useLetterActions();
    const { onSuccess, ...rest } = options;
    const { success, error } = useToast();
    const { accountId } = useCurrentAccount();

    return useMutation({
        mutationFn: (messageId: number) => deleteEngageMessage(accountId, messageId),
        onSuccess: (...args) => {
            success('Deleted letter successfully');
            invalidate({
                type: 'all',
                predicate: isQueryKeyIndexMeta,
            });
            onSuccess?.(...args);
        },
        onError: (e: GivebutterAxiosError) => {
            error(e.response?.data?.message ?? 'Failed to delete letter');
        },
        ...rest,
    });
};

export { useDeleteLetter };
